import type { LeadRequestType } from './lead-request-type.enum';

export interface SubmitLeadDto {
  name: string;
  surname: string;
  email: string;
  phone: string;
  requestType: LeadRequestType;
  // winepassport#334 — obligatorios cuando requestType es Sommelier
  region?: string;
  city?: string;
  postalCode?: string;
  academicInstitution?: string;
  instagram?: string;
}

export interface SubmitLeadResultDto {
  routed?: string;
}
